/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { destinationsDelete } from "../../funcs/destinationsDelete.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
  destinationId: z.string(),
};

export const tool$destinationsDelete: ToolDefinition<typeof args> = {
  name: "destinations-delete",
  description: `Delete Destination

Deletes a specific destination.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await destinationsDelete(
      client,
      args.tenantId,
      args.destinationId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
